import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView,
  ImageBackground,
} from "react-native";

import * as Animatable from "react-native-animatable";
import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 300;
let styles = {};
const img6 = require("../images/AboutUs/img6.png");
const img6mobile = require("../images/AboutUs/img6mobile.png");
const img8 = require("../images/AboutUs/img8.jpg");
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
let chevron = require("../images/chevron.png");
let chevron2 = require("../images/chevron2.png");

const chevronDown = require("../images/chevronDown.png");
const chevronUp = require("../images/chevronUP.png");

const chevronLeft = require("../images/AboutUs/chevronLeft.png");
const chevronRight = require("../images/AboutUs/chevronRight.png");
var historyButton = Styles.appColor1;
let isMobile = false;
let prevKey = 0;
class AboutUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      brands: [],
      ourHistory: [],
      joImgPos: 0,
      hideScrollTopButton: true,
      selectedHistPos: 0,
    };
  }
  Pressables = {};

  async componentDidMount() {
    const ourHistory = await ServerOperations.getHistory();
    this.setState({ ourHistory });
  }


  renderMobile = () => {
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          <View style={{ width, paddingHorizontal: 20, gap: 50, textAlign: 'center' }}>
            {Styles.renderVSeparator(100)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {this.renderPart3Mobile()}
            {this.renderPart4Mobile()}
            {this.renderPart5Mobile()}
            {/* {this.renderPart6Mobile()} */}
          </View>
          {Commons.renderFooter({}, this)}
        </ScrollView >
      </View>

    );
  }

  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"About us"}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}
          style={{ gap: 84 }}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {this.renderPart3()}
          {this.renderPart4()}
          {this.renderPart5()}
          {/* {this.renderPart6()} */}
          {/* {this.renderPart7()} */}
          {Commons.renderFooter({}, this)}
        </ScrollView >

      </View >
    );
  }


  renderPressableButton = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
            fontSize: 15
          }]}>{text}</Text>
          <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }


  // this is for the about us renderPart1 buttons
  renderPressableLink3 = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        style={{ height: width / 25 }}>
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color,
          width: width * 0.25,
        }}>

          <Text style={[Styles.TextStyle5, isHovered && { color }, textStyle, {
            fontSize: 22.5,
            // fontSize:width/62.2,
            paddingTop: 10,
          }]}>{text}</Text>
          <Image source={isHovered} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderCoreView = (key) => {
    if (isMobile) {
      if (prevKey == 1) this.ethicView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
      if (prevKey == 2) this.competenceView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
      if (prevKey == 3) this.respectView.animate({ 0: isMobile ? { height: 90, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
      if (prevKey == 4) this.qualityView.animate({ 0: isMobile ? { height: 150, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
      if (prevKey == 5) this.reliabilityView.animate({ 0: isMobile ? { height: 100, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
      if (prevKey == 6) this.sustainabilityView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 1) {
      this.ethicView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 120, opacity: 1 } }, 1000);
    }
    if (key == 2) {
      this.competenceView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 120, opacity: 1 } }, 1000);
    }
    if (key == 3) {
      this.respectView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 90, opacity: 1 } }, 1000);
    }
    if (key == 4) {
      this.qualityView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 150, opacity: 1 } }, 1000);
    }
    if (key == 5) {
      this.reliabilityView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 100, opacity: 1 } }, 1000);
    }
    if (key == 6) {
      this.sustainabilityView.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 120, opacity: 1 } }, 1000);
    }
    prevKey = key;
  }

  hideCoreView = (key) => {
    prevKey = 0;
    if (key == 1) {
      this.ethicView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 2) {
      this.competenceView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 3) {
      this.respectView.animate({ 0: isMobile ? { height: 90, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 4) {
      this.qualityView.animate({ 0: isMobile ? { height: 150, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 5) {
      this.reliabilityView.animate({ 0: isMobile ? { height: 100, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }
    if (key == 6) {
      this.sustainabilityView.animate({ 0: isMobile ? { height: 120, opacity: 1 } : { height: 0, opacity: 0 }, 1: { height: 0, opacity: 0 } }, 1000);
    }

  }


  renderCoreValuesEthics = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { this.setState({ hoveredComponent: undefined }) }}>
        <TouchableOpacity onPress={() => {
          onPress();
          if (isMobile) {
            if (this.Pressables[componentRef] == this.state.hoveredComponent) {
              this.hideCoreView(1);
              this.setState({ hoveredComponent: undefined })
            } else {
              this.setState({ hoveredComponent: this.Pressables[componentRef] })
            }
          }
        }} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.ethicView = el)} style={[{
          gap: 20, height: 0, opacity: 0,
        }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Ethics_and_Integrity}`.replace(/\n/g, "") : STRINGS.Ethics_and_Integrity}
          </Text>
        </Animatable.View>
      </Pressable>
    )
  }

  renderCoreValuesCompetence = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { { this.hideCoreView(2) }; this.setState({ hoveredComponent: undefined }) }}>
        <TouchableOpacity onPress={() => {
          onPress();
          if (isMobile) {
            if (this.Pressables[componentRef] == this.state.hoveredComponent) {
              this.hideCoreView(2);
              this.setState({ hoveredComponent: undefined })
            } else {
              this.setState({ hoveredComponent: this.Pressables[componentRef] })
            }
          }
        }} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.competenceView = el)} style={[{ gap: 20, height: 0, opacity: 0 }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Competence}`.replace(/\n/g, "") : STRINGS.Competence}
          </Text>
        </Animatable.View>
      </Pressable>
    )
  }

  renderCoreValuesRespect = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { { this.hideCoreView(3) }; this.setState({ hoveredComponent: undefined }) }}>
        <TouchableOpacity onPress={() => {
          onPress();
          if (isMobile) {
            if (this.Pressables[componentRef] == this.state.hoveredComponent) {
              this.hideCoreView(3);
              this.setState({ hoveredComponent: undefined })
            } else {
              this.setState({ hoveredComponent: this.Pressables[componentRef] })
            }
          }
        }} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,

        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.respectView = el)} style={[{ gap: 20, height: 0, opacity: 0 }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Respect_and_Diversity}`.replace(/\n/g, "") : STRINGS.Respect_and_Diversity}
          </Text>
        </Animatable.View>
      </Pressable>
    )
  }

  renderCoreValuesQuality = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { { this.hideCoreView(4) }; this.setState({ hoveredComponent: undefined }) }}>
        <TouchableOpacity onPress={
          () => {
            onPress();
            if (isMobile) {
              if (this.Pressables[componentRef] == this.state.hoveredComponent) {
                this.hideCoreView(4);
                this.setState({ hoveredComponent: undefined })
              } else {
                this.setState({ hoveredComponent: this.Pressables[componentRef] })
              }
            }
          }
        } style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.qualityView = el)} style={[{ gap: 20, height: 0, opacity: 0 }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Quality_and_Compliance}`.replace(/\n/g, "") : STRINGS.Quality_and_Compliance}
          </Text>
        </Animatable.View>
      </Pressable >
    )
  }

  renderCoreValuesReliability = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { { this.hideCoreView(5) }; this.setState({ hoveredComponent: undefined }) }}
      >
        <TouchableOpacity onPress={() => {
          onPress();
          if (isMobile) {
            if (this.Pressables[componentRef] == this.state.hoveredComponent) {
              this.hideCoreView(5);
              this.setState({ hoveredComponent: undefined })
            } else {
              this.setState({ hoveredComponent: this.Pressables[componentRef] })
            }
          }
        }} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.reliabilityView = el)} style={[{ gap: 20, height: 0, opacity: 0 }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Reliability}`.replace(/\n/g, "") : STRINGS.Reliability}
          </Text>
        </Animatable.View>
      </Pressable>
    )
  }

  renderCoreValuesSustainability = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => { { this.hideCoreView(6) }; this.setState({ hoveredComponent: undefined }) }}>
        <TouchableOpacity onPress={() => {
          onPress();
          if (isMobile) {
            if (this.Pressables[componentRef] == this.state.hoveredComponent) {
              this.hideCoreView(6);
              this.setState({ hoveredComponent: undefined })
            } else {
              this.setState({ hoveredComponent: this.Pressables[componentRef] })
            }
          }
        }} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle]}>{text}</Text>
          <Image source={isHovered ? chevron2 : chevron} style={{ height: 12, width: 12, marginBottom: -2 }} resizeMode="stretch" />
        </TouchableOpacity>
        <Animatable.View ref={el => (this.sustainabilityView = el)} style={[{ gap: 20, height: 0, opacity: 0 }]}>
          <Text style={[[Styles.TextStyle2, isMobile && { paddingVertical: 20, width: width - 60 }]]}>
            {isMobile ? `${STRINGS.Sustainability}`.replace(/\n/g, "") : STRINGS.Sustainability}
          </Text>
        </Animatable.View>
      </Pressable>
    )
  }



  renderPart1Mobile = () => {
    return (
      <View style={{
        gap: 20,
        textAlign: 'left'
      }}>
        <Text style={[Styles.TextStyle3]}>{STRINGS.about_us}</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          Established in 1949, Jordan Drugstore Co. (JDS) is a private shareholding company that
          has emerged as a leading force in Jordan's pharmaceutical and parapharmaceutical
          marketing and distribution landscape. Over the years, our portfolio has expanded to
          encompass a wide range of products, including ethical and over-the-counter
          medications, contrast media, and various healthcare and personal care essentials.
        </Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          From our headquarters in Amman, we proudly serve a diverse clientele across Jordan.
          Our extensive territorial coverage ensures that pharmacies, para-shops, hospitals, health
          centers, radiology facilities, and government institutions throughout the country benefit
          from our products and services.
        </Text>
        <Image source={img6mobile} style={{ height: 200, width: width - 40 }} resizeMode="contain" />
      </View>
    )
  }


  renderPart1 = () => {
    return (
      <View style={{
        paddingTop: 200,
        height: width / 4.66,
        marginLeft: 110,
        gap: 30,
      }}>
        <Text style={[Styles.TextStyle3]}>{STRINGS.about_us}</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          Established in 1949, Jordan Drugstore Co. (JDS) is a private shareholding company that
          {`\n`}has emerged as a leading force in Jordan's pharmaceutical and parapharmaceutical
          {`\n`}marketing and distribution landscape. Over the years, our portfolio has expanded to
          {`\n`}encompass a wide range of products, including ethical and over-the-counter
          {`\n`}medications, contrast media, and various healthcare and personal care essentials.
        </Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          From our headquarters in Amman, we proudly serve a diverse clientele across Jordan.
          {`\n`}Our extensive territorial coverage ensures that pharmacies, para-shops, hospitals, health
          {`\n`}centers, radiology facilities, and government institutions throughout the country benefit
          {`\n`}from our products and services.
        </Text>

        <View style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          width: width * 0.25,
          position: 'absolute',
          right: 80,
        }}>
          {this.renderPressableLink3('Our Purpose', { width: width * 0.25, }, () => this.mainScrollView.scrollTo({ animated: true, y: 1010 }))}
          {this.renderPressableLink3('Our Core Values', { width: width * 0.25, }, () => this.mainScrollView.scrollTo({ animated: true, y: 1450 }))}
          {this.renderPressableLink3('Our History', { width: width * 0.25, }, () => this.mainScrollView.scrollTo({ animated: true, y: 2450 }))}
        </View>
      </View>
    )
  }

  renderPart2 = () => {
    return (
      <ImageBackground source={img6} style={{ width: '100%', height: 400, marginTop: 300 }}>

      </ImageBackground>
    )
  }
  renderPart2Mobile = () => {
    return;
  }

  renderPart3 = () => {
    return (
      <View style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        gap: 30,
        flexShrink: 0,
        marginTop: 85
      }}>
        <View style={{ gap: 30, marginRight: 154 }}>
          <Text style={[Styles.TextStyle3]}>Our Purpose</Text>
          <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
            United by our shared responsibility to create healthier futures, we specialize in
            {`\n`}designing and delivering pharmaceutical and parapharmaceutical supply-chain
            {`\n`}solutions for unparalleled access, efficiency, and reliability, driving the progress
            {`\n`}of healthcare together in Jordan.
          </Text>
          {this.renderPressableLink('What We Do', { letterSpacing: 1.25 }, () => window.location = './service')}
        </View>

      </View>
    )
  }

  renderPart3Mobile = () => {
    return (
      <View style={{
        flexDirection: 'column',
        gap: 20,
        textAlign: 'left',
        paddingVertical: 50
      }}>
        <Text style={[Styles.TextStyle3]}>Our Purpose</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          United by our shared responsibility to create healthier futures, we specialize in
          designing and delivering pharmaceutical and parapharmaceutical supply-chain
          solutions for unparalleled access, efficiency, and reliability, driving the progress
          of healthcare together in Jordan.
        </Text>
        {this.renderPressableLink('What We Do', { letterSpacing: 1.25 }, () => window.location = './service')}
      </View>
    )
  }

  renderPart4 = () => {
    return (
      <View
        style={{
          display: 'flex',
          width: '100%',
          alignItems: "center",
          background: 'rgba(107, 164, 97, 0.11)',
          gap: 30,
          flexShrink: 0,
          marginTop: marginTop - 210,
          paddingVertical: 85,
        }}>
        <View style={{
          display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 32,
        }}>

          <View style={{ display: 'flex', width: 650, flexDirection: 'column', alignItems: 'flex-start', gap: 30, }}>
            <Text style={Styles.TextStyle3}>Our Core Values</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
              Our core values define our corporate culture and guide our actions,
              {`\n`}underpinning our mission to enhance healthcare accessibility and
              {`\n`}quality while maintaining our code of ethics.
            </Text>
          </View>

          <View style={{ flexDirection: 'row', gap: 220 }}>
            <View style={{ flexDirection: 'column', gap: 32 }}>
              {this.renderCoreValuesEthics('Ethics & Integrity', { width: width * 0.3, height: 32 }, () => this.renderCoreView(1))}
              {this.renderCoreValuesCompetence('Competence', { width: width * 0.3, height: 32 }, () => this.renderCoreView(2))}
              {this.renderCoreValuesRespect('Respect & Diversity', { width: width * 0.3, height: 32 }, () => this.renderCoreView(3))}
            </View>
            <View style={{ flexDirection: 'column', gap: 32 }}>
              {this.renderCoreValuesQuality('Quality & Compliance', { width: width * 0.3, height: 32 }, () => this.renderCoreView(4))}
              {this.renderCoreValuesReliability('Reliability', { width: width * 0.3, height: 32 }, () => this.renderCoreView(5))}
              {this.renderCoreValuesSustainability('Sustainability', { width: width * 0.3 - 5, height: 32 }, () => this.renderCoreView(6))}
            </View>
          </View>
        </View>
      </View>
    )
  }



  renderPart4Mobile = () => {
    return (
      <View
        style={{
          width,
          alignItems: "center",
          background: 'rgba(107, 164, 97, 0.11)',
          gap: 30,
          paddingVertical: 50,
          paddingHorizontal: 20,
          marginLeft: -20
        }}>
        <View style={{
          gap: 32,
          textAlign: 'left'
        }}>

          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 30, }}>
            <Text style={Styles.TextStyle3}>Our Core Values</Text>
            <Text style={[Styles.TextStyle2, {}]}>
              Our core values define our corporate culture and guide our actions,
              underpinning our mission to enhance healthcare accessibility and
              quality while maintaining our code of ethics.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: 33 }}>
            {this.renderCoreValuesEthics('Ethics & Integrity', { width: width - 70 }, () => this.renderCoreView(1))}
            {this.renderCoreValuesCompetence('Competence', { width: width - 70 }, () => this.renderCoreView(2))}
            {this.renderCoreValuesRespect('Respect & Diversity', { width: width - 70 }, () => this.renderCoreView(3))}
            {this.renderCoreValuesQuality('Quality & Compliance', { width: width - 70 }, () => this.renderCoreView(4))}
            {this.renderCoreValuesReliability('Reliability', { width: width - 70 }, () => this.renderCoreView(5))}
            {this.renderCoreValuesSustainability('Sustainability', { width: width - 70 }, () => this.renderCoreView(6))}
          </View>
        </View>
      </View>
    )
  }


  renderPart5 = () => {
    return (<View style={{
      // display: 'flex',
      width: '100%',
      height: 400,
      flexShrink: 0,
      marginTop: marginTop - 200,
      flexDirection: 'row',
      paddingLeft: 0,
      marginLeft: 1,
      alignItems: 'center',
    }}>
      <View style={{ height: 400, width: 600 }}>
        <Image source={img8} style={{ width: '100%', height: '100%' }} />
      </View>

      <View style={{ justifyContent: 'center', flexDirection: 'column', gap: 30, marginLeft: 175, width: 560 }}>
        <Text style={[Styles.TextStyle3]}>{STRINGS.make_deferent_with_us}</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
          We cultivate a dynamic workforce of approximately 200
          {`\n`}employees, fostering a culture that encourages professional
          {`\n`}growth and development.
        </Text>

        {/* {this.renderPressableLink('Job Openings', { gap: 8 }, () => this.props.navigation.navigate("careers", { v: new Date().getSeconds() }))} */}
        {this.renderPressableLink('Job Openings', { gap: 8 }, () => window.location = './careers')}
      </View>
    </View>)
  }


  renderPart5Mobile = () => {
    return (<View style={{
      alignItems: 'center',
      gap: 18,
      marginBottom: 50
    }}>
      <Text style={[Styles.TextStyle3]}>{STRINGS.make_deferent_with_us}</Text>
      <Image source={img8} style={{ height: 262, width: width - 40 }} resizeMode="cover" />

      <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
        We cultivate a dynamic workforce of approximately 200
        employees, fostering a culture that encourages professional
        growth and development.
      </Text>
      {this.renderPressableLink('Job Openings', { gap: 8 }, () => window.location = './careers')}
    </View>)
  }



  renderHistoryDescription = () => {
    if (this.state.ourHistory.length < 1) return <View />
    const histItem = this.state.ourHistory[this.state.selectedHistPos];
    const nowSelected = this.state.selectedHistPos;
    var nextYear = '';
    var prevYear = '';
    if (nowSelected == this.state.ourHistory.length - 1) {
      nextYear = 0;
    } else {
      nextYear = nowSelected + 1;
    }
    if (nowSelected == 0) {
      prevYear = 0;
    } else {
      prevYear = nowSelected - 1;
    }
    return (
      <Animatable.View ref={el => (this.descriptionView = el)} style={{ flexDirection: 'column', gap: 30, height: 130, width: '100%' }} >
        <TouchableOpacity style={{ width: 12, height: 12, position: 'absolute', left: isMobile ? -25 : -50, top: 200 }}
          onPress={() => this.setState({ selectedHistPos: prevYear })}>
          <Image source={chevronLeft} style={{ width: '100%', height: '100%', color: Styles.appColor3 }} resizeMode="stretch" ></Image>
        </TouchableOpacity>
        <TouchableOpacity style={{ width: 12, height: 12, position: 'absolute', right: isMobile ? -25 : 200, top: 200 }}
          onPress={() => this.setState({ selectedHistPos: nextYear })}>
          <Image source={chevronRight} style={{ width: '100%', height: '100%', color: Styles.appColor3 }} resizeMode="stretch" ></Image>
        </TouchableOpacity>
        <View></View>
        <Animatable.Text style={[Styles.TextStyle2, { maxWidth: 500, marginTop: 10 }]}>{histItem.ID}</Animatable.Text>
        <Animatable.Text style={[Styles.TextStyle2, { maxWidth: 500, color: Styles.appColor3 }]}>{histItem.PARAGRAPH}</Animatable.Text>
      </Animatable.View >
    )
  }



  renderPart6 = () => {
    const histItems = this.state.ourHistory.map(
      (item, index) => {
        const isSelected = this.state.selectedHistPos == index;
        return (
          <View>
            <TouchableOpacity onPress={() => this.setState({ selectedHistPos: index, selectedHeight: 14, selectedWidth: 14 })}>
              {isSelected &&
                <View style={{
                  height: 14, width: 14, borderRadius: 100,
                  borderWidth: 1, borderColor: Styles.appColor1, position: 'absolute', top: -4, left: -4
                }} />
              }
              <View
                style={{ height: 6.042, width: 6.042, borderRadius: 100, backgroundColor: historyButton }} />
              <Text style={[Styles.TextStyle2, { marginLeft: -15, marginTop: 5 }]}>{item.ID}</Text>
            </TouchableOpacity>
          </View>
        )
      }
    );
    var marginLeft = width - 1350;
    if (marginLeft < 140) {
      marginLeft = 140;
    }
    return (<View style={{
      width: width,
      height: 480,
      alignItems: 'flex-start',
      paddingHorizontal: 0.098 * width,
      flexShrink: 0,
      marginTop: 140,
      marginLeft: 0
    }}>
      <Text style={[Styles.TextStyle1, { fontSize: 35.16 }]}>{STRINGS.our_history}</Text>
      {this.renderHistoryDescription()}

      <View style={{ flexDirection: 'column', gap: 40, marginTop: 240 }}>
        <View style={{ flexDirection: "row", gap: 50, width, height: 200 }}>
          {histItems}
        </View>
        <View style={{ width: width - 300, height: 1, backgroundColor: Styles.appColor1, position: 'absolute', top: 3, marginLeft: 4 }} />
      </View>
      <View style={{ height: 10 }}></View>

    </View>)
  }

  renderPart6Mobile = () => {
    const histItems = this.state.ourHistory.map(
      (item, index) => {
        const isSelected = this.state.selectedHistPos == index;
        return (
          <View>
            <TouchableOpacity onPress={() => this.setState({ selectedHistPos: index, selectedHeight: 14, selectedWidth: 14 })}>
              {isSelected &&
                <View style={{
                  height: 14, width: 14, borderRadius: 100,
                  borderWidth: 1, borderColor: Styles.appColor1, position: 'absolute', top: -4, left: -4
                }} />
              }
              <View
                style={{ height: 6.042, width: 6.042, borderRadius: 100, backgroundColor: historyButton }} />
              <Text style={[Styles.TextStyle2, { marginLeft: -15, marginTop: 5 }]}>{item.ID}</Text>
            </TouchableOpacity>
          </View>
        )
      }
    );
    return (<View style={{
      height: 420,
      paddingHorizontal: 20,
      textAlign: 'left',
      marginBottom: 50
    }}>
      <Text style={[Styles.TextStyle1, { fontSize: 35.16 }]}>{STRINGS.our_history}</Text>
      <View style={{ width: width - 80 }}>
        {this.renderHistoryDescription()}
      </View>
      <View style={{ flexDirection: 'column', gap: 40, marginTop: 200 }}>
        <View style={{ flexDirection: "row", gap: 50, width: width - 80, height: 160 }}>
          {histItems}
        </View>
        <View style={{ width: width - 80, height: 1, backgroundColor: Styles.appColor1, position: 'absolute', top: 3, marginLeft: 4 }} />
      </View>
      <View style={{ height: 10 }}></View>
    </View>)
  }


  renderPart7 = () => {
    return (<View style={{ width, height: 150 }}>

    </View>

    )
  }


  styles = () => ({
    container: {
      flex: 1,
      width: width,
      alignItems: "center",
      backgroundColor: WHITE
    },
    image: {
      width,
      height: '650px',
      flexShrink: 0,
    }
  });
}



export default AboutUs;
